"use client"

import { useCartStorage } from "@lib/hooks/use-cart-storage"
import { useEffect, useRef, useState } from "react"

export default function QuantitySelector(props: {
  variantID: string
  value: number
  allowUserInput?: true
  step?: number
  onQuantityChanged: (quantity: number) => void
}) {
  const inputRef = useRef<HTMLInputElement>(null)

  const increaseQuantity = () => {
    props.onQuantityChanged(props.value + (props.step || 1))
  }

  const decreaseQuantity = () => {
    props.onQuantityChanged(props.value - (props.step || 1))
  }

  const handleUserQuantityChange = (userQuantity: string) => {
    props.onQuantityChanged(Number(userQuantity))
  }

  function handleFocus() {
    inputRef.current?.select()
  }

  return (
    <div className="flex flex-row items-center justify-center max-w-[110px] flex-shrink h-full">
      <button
        onClick={decreaseQuantity}
        className="w-8 py-2 pl-1 text-center text-xl font-bold bg-white rounded-l-full border border-l-[#E6E6E6] border-y-[#E6E6E6] border-r-[#F1F1F1] hover:font-bold hover:bg-[#F1F1F1]"
      >
        -
      </button>
      <input
        type="number"
        ref={inputRef}
        value={props.value}
        step={props.step || 1}
        onChange={(e) => handleUserQuantityChange(e.target.value)}
        disabled={props.allowUserInput}
        className="min-w-[25px] max-w-[50px] p-2 text-center text-lg bg-white border-y border-y-[#E6E6E6] w-auto [&::-webkit-inner-spin-button]:appearance-none 
                 [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]"
        min={0}
        pattern="^0$|^[1-9][0-9]*$"
        onFocus={handleFocus}
      />
      <button
        onClick={increaseQuantity}
        className="w-8 py-2 pr-2 pl-1 text-center text-xl font-bold bg-white rounded-r-full border-r-[#E6E6E6] border border-l-[#F1F1F1] hover:font-bold hover:bg-[#F1F1F1]"
      >
        +
      </button>
    </div>
  )
}
